<div class="mt4 mb4 mb6-ns" *ngIf="!!image && !!image?.length">
  <div class="jb-max-width center">
    <div
      class="jb-grid gr-unset"
      [ngClass]="{
        'grid-offset': image?.length === 1 || image?.length === 2,
        'one-up': image?.length === 1,
        'two-up': image?.length === 2,
        'three-up': image?.length > 2
      }"
    >
      <div
        *ngFor="let imageSection of image; let last = last; let i = index"
        class="image-container"
        [style.--aspect-ratio]="
          (hasImageHeightWidthAttr &&
          +imageSection?.image[0]?.height > 0 &&
          +imageSection?.image[0]?.width > 0
            ? (imageSection?.image[0]?.height / imageSection?.image[0]?.width) *
              100
            : realAspectRatio[i] ? realAspectRatio[i] : 56.25) + '%'
        "
      >
        <jb-image
          dotImageSize (dotOnImageLoad)="onImageLoad($event, i)"
          class="h-auto db mw-100"
          [src]="imageSection?.image[0]?.src"
          [alt]="imageSection?.image[0]?.alt"
          [height]="
            hasImageHeightWidthAttr && +imageSection?.image[0]?.height > 0
              ? imageSection?.image[0]?.height
              : null
          "
          [width]="
            hasImageHeightWidthAttr && +imageSection?.image[0]?.width > 0
              ? imageSection?.image[0]?.width
              : null
          "
          [placeholder]="
            imageSection?.image[0]?.src
              | dynamicImageWidthPipe: 'placeholder':placeholderParams
          "
          [isLazy]="enableLazyLoadImage"
        >
        </jb-image>

        <div *ngIf="imageSection?.title" class="db mt3-ns mt2 mb1 body b">
          {{ imageSection.title }}
        </div>
        <div
          *ngIf="imageSection?.caption"
          class="s-body mb0-ns"
          [ngClass]="{ mb4: image?.length !== 1 && !last }"
        >
          {{ imageSection.caption }}
        </div>
      </div>
    </div>
  </div>
</div>
